import { render, staticRenderFns } from "./PosterInspiration.vue?vue&type=template&id=5ebe68a3&"
import script from "./PosterInspiration.vue?vue&type=script&lang=ts&"
export * from "./PosterInspiration.vue?vue&type=script&lang=ts&"
import style0 from "./PosterInspiration.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports